import { faArrowLeft, faBars, faFloppyDisk, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { delActu, detailsActu, saveActu } from "../../actions/actus";
import { connect } from "react-redux";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";
import { getIdInUrl, tempAlWait } from "../../helpers";
import EditorActu from "../../components/editor/EditorActu";
import { ThemeProvider } from "@emotion/react";
import theme from "../../theme";
import { CssBaseline, Grid, Typography } from "@mui/material";

class AdminActuAdd extends React.Component {
    state = {
        menuActive: false,
        opts: [
            {
                type: 'link',
                ttl: "Retourner à la liste des actualités",
                ico: faArrowLeft,
                link: "/admin/actus",
                action: null,
                col: null
            }, {
                type: 'button',
                ttl: "Supprimer l'actualité",
                ico: faTrashCan,
                link: null,
                action: () => {
                    if (window.confirm("Souhaitez-vous réellement supprimer cette actualité ?")) {
                        this.setState({
                            alert: tempAlWait()
                        });
                        this.props.delActu({actuId: this.state.id})
                    }
                },
                col: "red"
            }
        ],
        form: {
            title: '',
            desc: '',
            codeYtb: '',
            duree: '',
            contenu: ''
        },
        alert: {
            active: false,
            type: '',
            title: "",
            desc: ""
        },
        id: null
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.setState({id: getIdInUrl()});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.setState({id: getIdInUrl()});
            }
        }

        if (prevState.id != this.state.id && this.state.id != null) {
            this.props.detailsActu({actuId: this.state.id});
        }
        if (prevProps.redSetActu != this.props.redSetActu) {
            this.setState({
                alert: this.props.redSetActu.alert
            })
        }
        if (prevProps.redDelActu != this.props.redDelActu) {
            this.setState({
                alert: this.props.redDelActu.alert
            })
        }
        if (prevProps.redDetActu != this.props.redDetActu) {
            if (this.props.redDetActu.alert.type == "succ") {
                this.setState({
                    alert: this.props.redDetActu.alert,
                    form: {
                        title: this.props.redDetActu.datas.title,
                        desc: this.props.redDetActu.datas.description,
                        codeYtb: this.props.redDetActu.datas.codeYtb,
                        duree: this.props.redDetActu.datas.duree,
                        contenu: this.props.redDetActu.datas.contenu,
                    }
                })
            } else {
                this.setState({
                    alert: this.props.redDetActu.alert
                })
            }
        }
    }

    handleSave(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        })
        this.props.saveActu({
            title: this.state.form.title,
            desc: this.state.form.desc,
            codeYtb: this.state.form.codeYtb,
            duree: this.state.form.duree,
            contenu: JSON.stringify(this.state.form.contenu),
            nbVue: 0,
            actuId: this.state.id,
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Modifier l'actualité"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Titre **/}
                    <div className="admin__inpgrp" title="Titre de l'actualité" aria-label="Titre de l'actualité">
                        <label htmlFor="actu-title" className="admin__lab">
                            Titre *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Titre"
                            className="admin__input"
                            id="actu-title"
                            value={this.state.form.title}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        title: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Description **/}
                    <div className="admin__inpgrp" title="Description courte de l'actualité" aria-label="Description courte de l'actualité">
                        <label htmlFor="actu-desc" className="admin__lab">
                            Résumé *
                        </label>
                        <textarea
                            required
                            placeholder="Résumé"
                            className="admin__input admin__input--txtarea" 
                            id="actu-desc"
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        desc: el.target.value
                                    }
                                }))
                            }}
                            value={this.state.form.desc}></textarea>
                    </div>

                    {/** Code Youtube **/}
                    <div className="admin__inpgrp" title="Code Youtube" aria-label="Code Youtube">
                        <label htmlFor="actu-codeytb" className="admin__lab">
                            Code Youtube *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="XXXXXXXXXXX"
                            className="admin__input"
                            id="actu-codeytb"
                            value={this.state.form.codeYtb}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        codeYtb: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Durée **/}
                    <div className="admin__inpgrp" title="Durée de lecture" aria-label="Durée de lecture">
                        <label htmlFor="actu-duree" className="admin__lab">
                            Durée de lecture
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="5 min"
                            className="admin__input"
                            id="actu-duree"
                            value={this.state.form.duree}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        duree: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Contenu **/}
                    <div className="admin__inpgrp" title="Contenu" aria-label="Contenu">
                        <label htmlFor="actu-contenu" className="admin__lab">
                            Contenu
                        </label>
                        <div className="admin__txtlib">
                            <ThemeProvider theme={theme}>
                                <CssBaseline />
                                <Grid container sx={{minHeight: "300px"}} flexDirection={"column"}>
                                    <Grid item xs={9}>
                                        <EditorActu
                                            handleChange={(el) => {
                                                this.setState(prevState => ({
                                                    form: {
                                                        ...prevState.form,
                                                        contenu: el,
                                                    }
                                                }))
                                            }}
                                            value={this.state.form.contenu}
                                        />
                                    </Grid>
                                </Grid>
                            </ThemeProvider>
                        </div>
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Modifier l'actualité"
                        aria-label="Modifier l'actualité"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSave(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Modifier</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redSetActu: state.redSetActu,
        redDetActu: state.redDetActu,
        redDelActu: state.redDelActu
    }
}

const mapDispatchToProps = {
    saveActu,
    detailsActu,
    delActu
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminActuAdd);